import { getTimelineItemByEntity, setStatus } from 'api/timelines'
import { useEffect, useMemo, useRef } from 'react'
import { useMutation, useQuery } from 'react-query'
import { useActions } from 'store/hooks'
import { ETimelinePostStatus, ETimelinePostType, QuestionnaireResultData } from 'types'

export function useQuestionnaireStatus(results?: QuestionnaireResultData) {
  const { getTimelineSilent } = useActions()
  const setStatusMutation = useMutation(setStatus)
  const isUpdated = useRef(false)

  const id = results?.questionnaireId

  const { data: timelineItem, isFetched: isTimelineFetched } = useQuery(
    'timelineExamItem',
    () => {
      if (!id) return

      return getTimelineItemByEntity(id, ETimelinePostType.questionnaire, {
        suppressErrorHandler: [404],
      })
    },
    {
      enabled: !!id,
    },
  )

  const timelineStatus = useMemo(() => {
    return timelineItem?.data?.status
  }, [timelineItem])

  useEffect(() => {
    if (
      isTimelineFetched &&
      timelineStatus === ETimelinePostStatus.new &&
      !isUpdated.current &&
      id &&
      results &&
      results.status === 'passed'
    ) {
      isUpdated.current = true
      setStatusMutation.mutate(
        {
          id,
          status: ETimelinePostStatus.done,
          type: ETimelinePostType.questionnaire,
        },
        {
          onSuccess: () => {
            getTimelineSilent()
          },
        },
      )
    }
  }, [getTimelineSilent, id, isTimelineFetched, setStatusMutation, timelineStatus, results])
}
